import { render, staticRenderFns } from "./u-tabs-inline.vue?vue&type=template&id=69faa76a&scoped=true"
import script from "./u-tabs-inline.vue?vue&type=script&lang=js"
export * from "./u-tabs-inline.vue?vue&type=script&lang=js"
import style0 from "./u-tabs-inline.vue?vue&type=style&index=0&id=69faa76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69faa76a",
  null
  
)

export default component.exports